import { DocTypeFiles } from 'shared/constants/docs';
import SelectFilesButton from 'shared/_model/project-files/SelectFilesButton';
import CreateFolderButton from 'app/_model/project/components/CreateFolderButton';

type Props = {
	type?: DocTypeFiles;
};

/** Icon tools of a file group header: "New folder" and the group "Select all" checkbox. */
export default function FileGroupTools({ type }: Props) {
	return (
		<>
			<CreateFolderButton type={type} />
			<SelectFilesButton type={type} />
		</>
	);
}
